/** Convert backend/email absolute URLs into in-app router paths. */
export function resolveNotificationInternalPath(url: string): string | null {
  const trimmed = url.trim()
  if (!trimmed) return null

  try {
    if (/^https?:\/\//i.test(trimmed)) {
      const parsed = new URL(trimmed)
      return `${parsed.pathname}${parsed.search}${parsed.hash || ""}`
    }
    return trimmed.startsWith("/") ? trimmed : `/${trimmed}`
  } catch {
    return null
  }
}

/** Map reports deep links to the generate-report wizard with the same query params. */
export function resolveNotificationReportsWizardPath(url: string): string | null {
  const internal = resolveNotificationInternalPath(url)
  if (!internal) return null

  try {
    const parsed = new URL(internal, "http://localhost")
    const path = parsed.pathname.replace(/\/+$/, "") || "/"
    const search = parsed.search

    if (path === "/reports/new") {
      return `/reports/new${search}`
    }
    if (path === "/reports") {
      return `/reports/new${search}`
    }
    if (path.startsWith("/reports/")) {
      return `/reports/new${search}`
    }

    return `/reports/new${search}`
  } catch {
    return null
  }
}

export function isNotificationActionUrlKey(key: string): boolean {
  return (
    key === "action_url" ||
    key === "actionUrl" ||
    key === "statistics_url" ||
    key === "statisticsUrl"
  )
}

export function isNotificationTradeReviewUrlKey(key: string): boolean {
  return key === "trade_review_url" || key === "tradeReviewUrl"
}

export function isNotificationReportsUrlKey(key: string): boolean {
  return key === "reports_url" || key === "reportsUrl"
}

export const NOTIFICATION_DETAIL_SUPPRESSED_KEYS = new Set([
  "action_label",
  "actionLabel",
  "statistics_url",
  "statisticsUrl",
  "dashboard_url",
  "dashboardUrl",
  "trade_log_url",
  "tradeLogUrl",
  "trade_review_url",
  "tradeReviewUrl",
  "reports_url",
  "reportsUrl",
  "action_url",
  "actionUrl",
])
